export class GtmEvent {

    event: string;
    eventCategory: string;
    eventAction: string;
    eventLabel: string;

    public static create(page: string, component: string, action: string, label: string) {
        const gtmEvent = new GtmEvent();
        gtmEvent.event = 'uaevent';
        gtmEvent.eventCategory = `${page}::${component}`;
        gtmEvent.eventAction = action;
        gtmEvent.eventLabel = label;
        return gtmEvent;
    }
}